import {Routes} from '@angular/router';
import {AdminListsPageComponent} from '../containers/admin-lists';
import {ListItemEditorPageComponent} from '../containers/list-item-editor';
import {LoggedInGuard} from '../guards/logged-in';

export const ListRoutes: Routes = [
  {
    path: '',
    component: AdminListsPageComponent,
    canActivate: [LoggedInGuard],
    data: {
      breadcrumb: 'List Home'
    }
  },
  {
    path: ':id',
    component: AdminListsPageComponent,
    canActivate: [LoggedInGuard],
    data: {
      breadcrumb: 'List Home'
    }
  },
  {
    path: 'editor/:parentId',
    component: ListItemEditorPageComponent,
    canActivate: [LoggedInGuard],
    data: {
      breadcrumb: 'Add List Item'
    }
  },
  {
    path: 'editor/:parentId/:id',
    component: ListItemEditorPageComponent,
    canActivate: [LoggedInGuard],
    data: {
      breadcrumb: 'Edit List Item'
    }
  }
];



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/routes/list.ts